import React, {memo, useCallback, useMemo, useState} from 'react';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {InputModel} from '../../../../types/control';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useSelector} from 'react-redux';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useHistory} from 'react-router-dom';

const columns: ColumnModel[] = [
    {
        length: 3,
        name: 'İnput Adı',
        key: 'name',
    },
    {
        length: 2,
        name: 'Cihaz',
        key: 'bridge_device_id',
    },
    {
        length: 2,
        name: 'Tipi',
        key: 'type_id',
    },
    {
        length: 1,
        name: 'Giriş',
        key: 'input_number',
    },
];

const keyExtractor = (item: InputModel) => item.id;

export const InputListScreen = memo(function InputListScreen() {

    const history = useHistory();

    const bridgeDeviceSet = useSetSelector(state => state.control.bridgeDeviceList);
    const inputList = useSelector(state => state.control.inputList);
    const inputTypeSet = useSetSelector(state => state.control.inputTypeList);

    const [selectedInput, setSelectedInput] = useState<InputModel>(null);

    const onCopyClick = useCallback(() => {
        history.push({pathname: '/settings/input/edit', state: {input: {...selectedInput, id: null}}});
    }, [history, selectedInput]);

    const buttons = useMemo(() => [
        {
            text: 'KOPYALA',
            onClick: onCopyClick,
            className: 'blue',
            hidden: !(selectedInput),
        },
        {
            text: 'DÜZENLE',
            url: `/settings/input/edit/${selectedInput ? selectedInput.id : ''}`,
            className: 'orange',
            hidden: !(selectedInput),
        },
        {
            text: 'İnput OLUŞTUR',
            url: '/settings/input/edit',
            className: 'green',
        },
    ], [onCopyClick, selectedInput]);

    const displayNameExtractor = useCallback((item: InputModel, column: ColumnModel) => {
        if (column.key === 'bridge_device_id') {
            return bridgeDeviceSet[item.bridge_device_id].name;
        }

        if (column.key === 'type_id') {
            return inputTypeSet[item.type_id].name;
        }

        return item[column.key]?.toString() || '-';
    }, [bridgeDeviceSet, inputTypeSet]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={'/settings'} searchable={true}>
                <SettingsList
                    columns={columns}
                    items={inputList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedInput}
                    onItemSelected={setSelectedInput}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
